export const FILTER_IDS = {
  SHOW_ARCHIVED_DESTINATIONS: 'showArchivedDestinations',
} as const;
